import { api } from "./_client";

export async function disableMyAccount() {
    const { data } = await api.post("/auth/account/disable");
    return data;
}

// Public: redeem a reactivation token from the email link.

export async function reactivateByToken(token) {
    const { data } = await api.post("/auth/reactivate", { token });
    return data; // { access_token, user }
}

// ============================================================
// iter-101 — Email client (IMAP + SMTP)
// ============================================================
